import { useRef, useState } from "react";

const isFileDrag = (event) =>
  Array.from(event.dataTransfer?.types || []).includes("Files");

/**
 * Detecta archivos arrastrados sobre un contenedor.
 * Devuelve `isDragging` y los handlers a esparcir en el contenedor.
 */
export const useFileDrop = ({ onFiles, disabled = false }) => {
  const [isDragging, setIsDragging] = useState(false);
  const depthRef = useRef(0);

  const dropHandlers = {
    onDragEnter: (event) => {
      if (!isFileDrag(event)) return;
      event.preventDefault();
      depthRef.current += 1;
      if (!disabled) setIsDragging(true);
    },
    onDragOver: (event) => {
      if (!isFileDrag(event)) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = disabled ? "none" : "copy";
    },
    onDragLeave: (event) => {
      if (!isFileDrag(event)) return;
      depthRef.current = Math.max(0, depthRef.current - 1);
      if (depthRef.current === 0) setIsDragging(false);
    },
    onDrop: (event) => {
      if (!isFileDrag(event)) return;
      event.preventDefault();
      depthRef.current = 0;
      setIsDragging(false);
      if (disabled) return;
      const files = Array.from(event.dataTransfer.files || []);
      if (files.length > 0) onFiles(files);
    },
  };

  return { isDragging, dropHandlers };
};

export default useFileDrop;
